export default __webpack_public_path__ + "static/media/section3_bg2.cd311b98.svg";